'use strict'
/**
 * View for component Loader
 * @returns html to view loader block
 */

class View {
  appendLoader () {
    const view = /* html */
        `
        
        `
    return view
  }
}

export default View